import { render } from "./App.vue?vue&type=template&id=3e3ea7c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3e3ea7c4&lang=scss"

import exportComponent from "C:\\Users\\riverside\\project\\mall\\skill-supply\\skill-supply-mall-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__